import { defineStore } from "pinia";
export type TBannerType = "info" | "warning" | "error";

export const ignoreRouteNames: string[] = [];

interface BannerData {
    type: TBannerType;
    text?: string;
    translationKey?: string;
    translationParams?: Record<string, string | number>;
}

export const useSystemBannersStore = defineStore("systemBanners", {
    state: () => ({
        bannerData: null as null | BannerData,
        closeCallback: null as null | (() => void),
    }),
    getters: {
        banner(state) {
            return state.bannerData;
        },
    },
    actions: {
        setBanner(text: string, type: TBannerType = "info", callback?: () => void) {
            this.bannerData = {
                type,
                text,
            };
            this.closeCallback = callback ?? null;
        },
        setBannerWithTranslation(
            translationKey: string,
            translationParams: Record<string, string | number>,
            type: TBannerType = "info",
            callback?: () => void,
        ) {
            this.bannerData = {
                type,
                translationKey,
                translationParams,
            };
            this.closeCallback = callback ?? null;
        },
        close() {
            this.bannerData = null;
            if (this.closeCallback) {
                this.closeCallback();
                this.closeCallback = null;
            }
        },
    },
});
